import React from 'react';

function MoveRight({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M12 16H24" />
      <path d="M8 7L8 25" />
      <path d="M19 21L24 16L19 11" />
    </svg>
  );
}

export default MoveRight;
